import React from 'react';
import styled from 'styled-components';

import media from '../../../utils/mediaQueries';
import Btn from '../../buttons/Btn';
import {
  colors, radius, shadows, spacing,
} from '../tokens';
import { SituationOption } from '../types';
import { SituationOptionGroup } from './SituationOptionGroup';

const Wrapper = styled.div`
  max-width: 820px;
  margin: 0 auto;
  padding: ${spacing.xl};
  background-color: ${colors.surface};
  border: 1px solid ${colors.border};
  border-radius: ${radius.large};
  box-shadow: ${shadows.card};

  ${media.mobile`
    padding: 20px;
  `}
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${colors.text};
  margin: 0 0 ${spacing.sm};

  ${media.mobile`
    font-size: 24px;
  `}
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: ${colors.textMuted};
  margin: 0;
`;

type SituationSelectorProps = {
  options: SituationOption[];
  selectedSituation: string | null;
  onSelectSituation: (value: string) => void;
  onSubmit: () => void;
};

const SituationSelector: React.FC<SituationSelectorProps> = ({
  options,
  selectedSituation,
  onSelectSituation,
  onSubmit,
}) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <Wrapper>
      <Title>Que souhaitez-vous faire ?</Title>
      <Text>
        Choisissez la situation qui vous correspond le mieux. Vous pourrez préciser votre besoin à
        l’étape suivante.
      </Text>
      <form onSubmit={handleSubmit}>
        <SituationOptionGroup
          name="situation"
          ariaLabel="Que souhaitez-vous faire ?"
          options={options}
          selectedValue={selectedSituation}
          onSelect={onSelectSituation}
        />
        <Btn type="submit" name="demarches-continue" text="Continuer" block disabled={!selectedSituation} />
      </form>
    </Wrapper>
  );
};

export { SituationSelector };
